import AutocompleteFieldBase from '../base/AutocompleteField';
import createField from './createField';

const AutocompleteField = createField(AutocompleteFieldBase);

export default AutocompleteField;
